module.exports = __webpack_public_path__ + "static/img (2)-f59ed530320c12f741a1147bac464a7a.jpg";